import Vue from 'vue';

/**
 * Retrieves ICW Widget data: links, perils, underwriter
 * @param {string} clientId
 * @param {import('./types').RetrieveICWWidgetDataParams} params
 * @returns {Promise<AxiosResponse<import('./types').ICWWidgetData>>}
 */
const retrieveICWWidgetData = (client, params) => Vue.axios.get(`/clients/${client}/widgets/icw`, { params });

export default {
  retrieveICWWidgetData,
};
